import React from "react";
import { Button, Stack } from "@mui/material";
import styled from "styled-components";
import { Link as RouteLink } from "react-router-dom";
import teapot from "src/assets/icons/teapot";
import spaceshipDb from "src/assets/icons/spaceship-db";
import Icon from "src/components/icon";
import { useOrg } from "src/components/providers/org-provider";

const H2 = styled.h2`
    font-size: 22px;
    font-weight: 500;
    margin: 0;
    color: ${({ theme }) => theme.palette.error.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const BorderedStack = styled(Stack)`
    border: ${({ theme }) => `3px dashed ${theme.palette.background.paper}`};
    border-radius: 14px;
    width: 100%;
`;

const BodyText = styled.p`
    font-size: 14px;
    font-weight: 300;
    margin: 0;
`;

const TeamLimitLow = ({ teamId }) => {
    const { org } = useOrg();

    return (
        <BorderedStack
            spacing={2}
            direction="column"
            justifyContent="center"
            alignItems="center"
            p={10}
            m={3}
        >
            <Icon svg={spaceshipDb} width="100px" height="auto" opacity="0.3" />
            <Stack alignItems="center">
                <Icon svg={teapot} width="260px" height="260px" opacity="0.2" />
                <H2>418 I’m a teapot</H2>
                <Span style={{ marginBottom: "3rem" }}>
                    A team should have at least {org.minimumTeamMembers || 3} members to enable
                    dashboard data.{" "}
                </Span>
                <BodyText>Please add more team mates and come back!</BodyText>
            </Stack>
            <Button
                variant="contained"
                component={RouteLink}
                to={`/teams/${teamId}`}
                data-testid="dashboard-link"
            >
                Edit Team
            </Button>
        </BorderedStack>
    );
};

export default TeamLimitLow;
